// 고객센터(넓은 패널): 버그 신고 · 건의 · 1:1 문의 · 내 글 답변 보기 + 최근 내 글 · 기록 보관 안내.
// 글쓰기·상세·답변 보기는 게시판 화면(board.js)을 그대로 쓴다(ctx.go('board', {compose} | {mine})) — 같은 글이 한곳에 모인다.
import { button, clear, el } from '../dom.js';
import { icon } from '../icons.js';
import { boardCategory, dateTimeText, errorMessage, statusChip } from '../format.js';

const MENU = [
  { id: 'bug', title: '버그 신고', desc: '오류·멈춤·이상한 동작', icon: 'bug', tone: 'red', go: { compose: 'bug' } },
  { id: 'idea', title: '건의', desc: '바라는 기능·바꿀 점', icon: 'bulb', tone: 'blue', go: { compose: 'idea' } },
  { id: 'inquiry', title: '1:1 문의', desc: '결제·계정·이용 제한', icon: 'lock', tone: 'gold', go: { compose: 'inquiry' } },
  { id: 'mine', title: '내 글 답변 보기', desc: '운영자 답변·처리 상태', icon: 'reply', tone: '', go: { mine: true } },
];

export function createSupportView(ctx) {
  const { client } = ctx;
  const root = el('div', 'tls-view');
  const wrap = el('div', 'tls-section tls-support');
  const head = el('div', 'tls-section-head');
  head.append(icon('help', 20), el('span', '', '고객센터'));
  const body = el('div', 'tls-scroll');
  wrap.append(head, body);
  root.append(wrap);

  let recent = null;
  let recentError = '';
  let loading = false;

  async function loadRecent() {
    if (loading || !client.state.me) return;
    loading = true;
    const r = await client.board({ mine: true });
    loading = false;
    if (r.ok && r.data) { recent = (r.data.items || []).slice(0, 3); recentError = ''; }
    else recentError = r.error;
    render();
  }

  function render() {
    clear(body);
    const tiles = el('div', 'tls-stiles');
    for (const m of MENU) {
      const t = button('tls-stile' + (m.tone ? ' tone-' + m.tone : ''), null, () => ctx.go('board', m.go), { 'data-support': m.id });
      t.append(icon(m.icon, 26), el('b', '', m.title), el('small', '', m.desc));
      tiles.append(t);
    }
    body.append(tiles);

    // 최근 내 글(답변 도착 확인)
    const box = el('div', 'tls-srecent');
    box.append(el('div', 'tls-hint', '최근 내 글'));
    if (!client.state.me) box.append(el('p', 'tls-note', '닉네임을 정하면 버그·건의·문의를 남기고 답변을 받을 수 있어요.'));
    else if (recent === null) box.append(el('p', 'tls-note', loading ? '불러오는 중…' : recentError ? errorMessage(recentError) : ''));
    else if (!recent.length) box.append(el('p', 'tls-note', '아직 남긴 글이 없어요.'));
    else {
      for (const post of recent) {
        const cat = boardCategory(post.category), status = statusChip(post);
        const row = button('tls-srow', null, () => ctx.go('board', { mine: true }), { 'data-support-post': String(post.id) });
        const badge = el('span', 'tls-cat tone-' + cat.tone);
        badge.append(icon(cat.icon, 12), el('span', '', cat.label));
        row.append(badge, el('span', 'tls-ptitle', post.title));
        if (post.devReply) { const r = el('span', 'tls-status tone-green'); r.append(icon('reply', 12), el('span', '', '답변 있음')); row.append(r); }
        else if (status.label) { const st = el('span', 'tls-status tone-' + status.tone); st.append(el('span', '', status.label)); row.append(st); }
        else row.append(el('span', 'tls-time', dateTimeText(post.createdAt)));
        box.append(row);
      }
    }
    body.append(box);

    // 처리 방식·개인정보 안내(PRD §3·§4)
    const policy = el('div', 'tls-spolicy');
    policy.append(
      el('div', '', '보통 하루 안에 운영자가 확인하고, 고친 내용은 글에 "수정됨(버전)"으로 답해 드려요.'),
      el('div', '', '버그 신고에는 게임 버전·기기 종류·화면 크기·최근 오류 요약이 함께 가요. 이름·연락처 같은 개인정보는 들어가지 않아요.'),
      el('div', '', '채팅 내용은 30일 뒤 자동으로 지워져요. 신고된 대화의 일부만 처리 완료 후 90일까지 보관해요.'),
    );
    body.append(policy);
    // 개인정보처리방침·이용약관·계정 삭제 안내(게임이 넘긴 링크, 새 탭)
    const legal = ctx.legalLinks();
    if (legal.length) {
      const row = el('div', 'tls-slegal', null, { 'data-support-legal': '1' });
      for (const link of legal) row.append(el('a', '', link.label, { href: link.href, target: '_blank', rel: 'noopener noreferrer' }));
      body.append(row);
    }
    const discord = ctx.discordInvite();
    if (discord) {
      const a = el('a', 'tls-btn tls-btn-discord', null, { href: discord, target: '_blank', rel: 'noopener noreferrer' });
      a.append(icon('discord', 18), el('span', '', '디스코드 참여'));
      body.append(a);
    }
  }

  return {
    el: root,
    show() { render(); loadRecent(); },
    hide() {},
    refresh() { if (recent === null && client.state.me && !loading) loadRecent(); },
  };
}
